// extracted by mini-css-extract-plugin
export default {"wrapper":"Book_wrapper__olUcu","mainBlock":"Book_mainBlock__fklAn","crumb":"Book_crumb__8y-YL","previewWrapper":"Book_previewWrapper__nADL3","error":"Book_error__SR-Mf"};